import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"min-height":"60vh"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "loader" }, null, -1)
const _hoisted_3 = {
  key: 1,
  style: {"min-height":"500px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "loader" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModuleLayout = _resolveComponent("ModuleLayout")
  const _component_AdminToolbar = _resolveComponent("AdminToolbar")
  const _component_VirtualRouterDemo = _resolveComponent("VirtualRouterDemo")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.pageData.PageId !== 0)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", {
            class: {'hide-overlay': !_ctx.initialLoader}
          }, null, 2),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.pageData.Template.MasterPagePathVue), {
            "show-only-content": _ctx.pageData.ModulePreviewMode
          }, {
            default: _withCtx(() => [
              (!_ctx.appState.loadingNewPage)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    (_ctx.moduleToShow.length && !_ctx.virtualPageLoading)
                      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.moduleToShow, (comp, i) => {
                          return (_openBlock(), _createBlock(_component_ModuleLayout, {
                            key: comp.Module.ModulLayoutID,
                            "module-info": comp,
                            index: i
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(comp.Module.ModuleVariation?.Title?.replace(/\s/g, '')), { "module-info": comp }, null, 8, ["module-info"]))
                            ]),
                            _: 2
                          }, 1032, ["module-info", "index"]))
                        }), 128))
                      : (_openBlock(), _createBlock("div", _hoisted_1, [
                          _hoisted_2
                        ]))
                  ], 64))
                : (_openBlock(), _createBlock("div", _hoisted_3, [
                    _hoisted_4
                  ]))
            ]),
            _: 1
          }, 8, ["show-only-content"]))
        ], 64))
      : _createCommentVNode("", true),
    (!_ctx.pageData.IsProduction)
      ? (_openBlock(), _createBlock(_component_AdminToolbar, {
          key: 1,
          modules: _ctx.pageData,
          "show-admin-toolbar": _ctx.showAdminToolbar
        }, null, 8, ["modules", "show-admin-toolbar"]))
      : _createCommentVNode("", true),
    (_ctx.appState.showVirtualRouter)
      ? (_openBlock(), _createBlock(_component_VirtualRouterDemo, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}